import React from 'react'
import zxcvbn from 'zxcvbn'

export const usePasswordStrengthMeter = () => {
  return {
    measure: zxcvbn,
  }
}
